import { fittedTailors, madwalletExtension, verifiedCreators, odogwuHunterImg, freightSync, gigLogistics, xendFinance,  } from "assets";

export const projectData = [
    {
        name: "Hammer Games",
        description: "An interactive web and mobile gaming platform that offers users an immersive and authentic African themed gaming experience.",
        tech: ["Typescript", "React", "Redux", "Tailwind CSS", "Socket.io", "SASS"],
        url: "https://hammergames.com/",
        image: odogwuHunterImg,
        id: 1
    },
    {
        name: "Fitted Tailors Portal",
        description: "Get your clients measurement from anywhere",
        tech: ["Javascript", "React", "Redux", "SASS", "Chakra UI"],
        url: "https://fitted.fashion/tailors",
        image: fittedTailors,
        id: 7
    },
    {
        name: "MadWallet Extension",
        description: "A decentralized cross-browser wallet extension for sending, saving, swapping and bridging crypto assets.",
        tech: ["Javascript", "React", "Redux", "SASS", "Web3.js", "Jest"],
        url: "https://chromewebstore.google.com/detail/madwallet/gcbjmdjijjpffkpbgdkaojpmaninaion?hl=en",
        image: madwalletExtension,
        id: 6
    },
    
    {
        name: "GIG Logistics",
        description: "A leading last mile logistics service provider in Nigeria and Ghana with expansion in the UK, Canada and USA.",
        tech: ["Typescript", "React", "NodeJs", "Tailwind CSS", "SASS"],
        url: "https://giglogistics.com/",
        image: gigLogistics,
        id: 3
    },
    {
        name: "Xend Finance",
        description: "The first DeFi project out of Africa backed by Binance and Google.",
        tech: ["Typescript", "React", "Redux", "Tailwind CSS", "Web3Js", "Rest API"],
        url: "https://xend.finance/",
        image: xendFinance,
        id: 4
    },
    
    {
        name: "Verified Creators",
        description: "Secure your web3 identity, differentiate yourself from web3 scammers and eradicate the trust friction.",
        tech: ["Javascript", "Typescript", "React", "Redux", "SASS",],
        url: "https://www.verifiedcreators.io/",
        image: verifiedCreators,
        id: 5
    },
    {
        name: "FreightSync",
        description: "A logistics solution that engages in all types of shipment and freight such as shipping, air cargo and land delivery.",
        tech: ["Javascript", "Typescript", "NextJs", "NodeJs", "Express"],
        url: "https://portal.thefreightsync.com/",
        image: freightSync,
        id: 2
    },
    
    
    
    
    // {
    //     name: "Xend Finance",
    //     description: "",
    //     tech: ["Javascript", "Typescript", "React", "Redux", "SASS",],
    //     url: "https://xend.finance/",
    //     image: xendWebsite,
    //     id: 8
    // },
    
]